<script setup lang="ts">
import { userModule } from '@/store/user/module'
import { computed, nextTick, onMounted, ref } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const {
    ModalContainer,
    Button: PocketButton,
} = UIKit

const emit = defineEmits<{
    close: []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const dialogRef = ref<HTMLElement | null>(null)

onMounted(async () => {
    await nextTick()
    dialogRef.value?.focus()
})
</script>

<template>
    <Portal to="modal">
        <ModalContainer
            key="aboutAITutorModal"
            :show-close-button="true"
            :is-dark-mode="isDarkMode"
            @close="emit('close')"
        >
            <div
                class="about-ai-tutor-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="about-ai-tutor-modal-title"
                aria-describedby="about-ai-tutor-modal-content"
            >
                <div
                    id="about-ai-tutor-modal-title"
                    ref="dialogRef"
                    class="about-ai-tutor-modal__title"
                    role="heading"
                    aria-level="2"
                    aria-describedby="about-ai-tutor-modal-content"
                    tabindex="-1"
                >
                    About Tutor
                </div>
                <div
                    id="about-ai-tutor-modal-content"
                    class="about-ai-tutor-modal__content"
                >
                    Tutor is powered by AI and is informed by trusted, exam-specific study materials.
                    Rather than giving you the answer directly,
                    Tutor guides you to discover the answer and deepen your learning.
                    AI can occasionally make mistakes, so review the question's explanation.
                </div>
                <PocketButton
                    class="about-ai-tutor-modal__close-btn"
                    :isDarkMode="isDarkMode"
                    @click="emit('close')"
                    @keydown.enter.stop.prevent="emit('close')"
                >
                    Close
                </PocketButton>
            </div>
        </ModalContainer>
    </Portal>
</template>

<style lang="scss" scoped>
.about-ai-tutor-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px 40px 24px;

    &__title {
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
        letter-spacing: 0.3px;
        text-align: center;
        margin-bottom: 12px;
    }

    &__content {
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        width: 294px;
        margin-bottom: 32px;
    }
}
</style>
